import { render, staticRenderFns } from "./insertModal.vue?vue&type=template&id=aa2ed0f2"
import script from "./insertModal.vue?vue&type=script&lang=js"
export * from "./insertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports